import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getOne from 'utils/getOne'

interface useInitProps {
  getValues: Function
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    // fetch the device if edit
    getOne(apiUrls.users + '/' + apiUrls.actionAccount).then((data) => {
      props.reset(data)

      props.setDataLoaded(true)
      props.setShowOverlay(false)
    })
  }, [props.currentCustomer])
}

export default useInit
